(function () {
  'use strict';
 
  function $(selector, root) { return (root || document).querySelector(selector); }
  function $$(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
 
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
 
  /* Formato de precios según la moneda de la tienda, sin ",00" al final. */
  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    var fmt = String(format || '${{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function delimit(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var dec = parts[1] && parts[1] !== '00' ? decimal + parts[1] : '';
      return whole + dec;
    }
    var value;
    switch (key) {
      case 'amount': value = delimit(2, ',', '.'); break;
      case 'amount_no_decimals': value = delimit(0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(2, "'", '.'); break;
      default: value = delimit(2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
 
  var ICONS = {
    truck: '<svg class="np-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
    trash: '<svg class="np-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"/></svg>',
    cart: '<svg class="np-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V7a3 3 0 0 1 6 0v1"/></svg>',
    gift: '<svg class="np-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7c-2-3-5.5-3-5.5-.8C6.5 7.5 9 7 12 7Zm0 0c2-3 5.5-3 5.5-.8 0 1.3-2.5.8-5.5.8Z"/></svg>'
  };
 
  /* ---------- Carrito lateral ---------- */
  var NatyCart = (function () {
    var drawer, panel, body, foot, rows, ship, protect, protectInput, timerEl, timerText, timerId = null;
    var config = {}, lastFocus = null, busy = false, cart = null, cleaning = false;
    var TIMER_KEY = 'npCartTimerEnd';
 
    function isProtection(item) {
      return !!(config.protection && Number(item.variant_id) === Number(config.protection.variantId));
    }
 
    function money(cents) { return formatMoney(cents, config.moneyFormat); }
    function sized(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
    function available() { return !!drawer; }
 
    function setCount(count) {
      $$('[data-np-cart-count]').forEach(function (el) {
        el.textContent = count;
        if (el.classList.contains('np-header__count')) el.hidden = count === 0;
      });
    }
 
    function packFor(qty) {
      var packs = (config.packs || []).slice().sort(function (a, b) { return a.qty - b.qty; });
      var best = null;
      packs.forEach(function (pack) { if (pack.qty <= qty) best = pack; });
      return best;
    }
    function nextPack(qty) {
      var packs = (config.packs || []).slice().sort(function (a, b) { return a.qty - b.qty; });
      for (var i = 0; i < packs.length; i += 1) { if (packs[i].qty > qty) return packs[i]; }
      return null;
    }
    function kachingValue(pack) {
      return JSON.stringify({ deal: config.deal, pp: Number(config.productId), main: true, v: config.version, bid: pack.bar });
    }
 
    function shipHTML(count) {
      var need = Number(config.freeQty) || 0;
      if (!need || !count) return '';
      if (count >= need) {
        return '<p class="np-ship np-ship--done">' + ICONS.truck + '<span><b>¡Felicitaciones!</b> Desbloqueaste el <b>envío gratis</b></span></p>' +
          '<span class="np-ship__bar"><span style="width:100%"></span></span>';
      }
      var missing = need - count;
      return '<p class="np-ship">' + ICONS.truck + '<span>Sumá <b>' + missing + (missing === 1 ? ' caja más' : ' cajas más') + '</b> y el envío es <b>gratis</b></span></p>' +
        '<span class="np-ship__bar"><span style="width:' + Math.round(count / need * 100) + '%"></span></span>';
    }
 
    function itemHTML(entry) {
      var item = entry.item;
      var line = entry.line;
      var discounts = (item.line_level_discount_allocations || []).map(function (allocation) {
        var title = allocation.discount_application && allocation.discount_application.title;
        return '<span class="np-drawer__disc">' + esc(title || 'Descuento') + ' · −' + money(allocation.amount) + '</span>';
      }).join('');
      var strike = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="np-drawer__variant">' + esc(item.variant_title) + '</p>' : '';
      var image = item.image ? '<img src="' + esc(sized(item.image, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '';
      var boxes = item.quantity === 1 ? '1 caja' : item.quantity + ' cajas';
      return '<article class="np-drawer__item">' +
        '<div class="np-drawer__img">' + image + '</div>' +
        '<div class="np-drawer__info">' +
          '<div class="np-drawer__top"><h3>' + esc(item.product_title) + '</h3>' +
          '<button type="button" class="np-drawer__remove" data-np-line="' + line + '" data-np-set="0" aria-label="Quitar ' + esc(item.product_title) + '">' + ICONS.trash + '</button></div>' +
          variant + discounts +
          '<div class="np-drawer__bottom">' +
            '<div class="np-drawer__stepper" role="group" aria-label="Cantidad">' +
              '<button type="button" data-np-line="' + line + '" data-np-set="' + (item.quantity - 1) + '" aria-label="Quitar una caja"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
              '<span aria-live="polite">' + boxes + '</span>' +
              '<button type="button" data-np-line="' + line + '" data-np-set="' + (item.quantity + 1) + '" aria-label="Sumar una caja">+</button>' +
            '</div>' +
            '<div class="np-drawer__price"><strong>' + money(item.final_line_price) + '</strong>' + strike + '</div>' +
          '</div>' +
        '</div>' +
      '</article>';
    }
 
    function upsellHTML(entries) {
      var mains = entries.filter(function (entry) { return Number(entry.item.variant_id) === Number(config.variantId); });
      if (entries.length !== 1 || mains.length !== 1) return '';
      var main = mains[0];
      var next = nextPack(main.item.quantity);
      if (!next) return '';
      var save = next.compare - next.total;
      var freeShip = config.freeQty && next.qty >= config.freeQty && main.item.quantity < config.freeQty;
      return '<div class="np-upsell">' +
        '<span class="np-upsell__icon">' + ICONS.gift + '</span>' +
        '<div class="np-upsell__text"><b>Pasate al ' + esc(next.title) + '</b>' +
        '<span>' + money(next.total) + (save > 0 ? ' · ahorrás ' + money(save) : '') + (freeShip ? ' + envío gratis' : '') + '</span></div>' +
        '<button type="button" class="np-upsell__btn" data-np-line="' + main.line + '" data-np-set="' + next.qty + '">Cambiar</button>' +
      '</div>';
    }
 
    /* Temporizador del carrito (se guarda en la sesión del navegador). */
    function timerEnd() {
      var end = 0;
      try { end = Number(sessionStorage.getItem(TIMER_KEY)) || 0; } catch (e) { end = 0; }
      if (!end) {
        end = Date.now() + (Number(config.timer && config.timer.minutes) || 5) * 60000;
        try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
      }
      return end;
    }
    function tickTimer() {
      if (!timerEl || !config.timer || !config.timer.enabled) return;
      var left = Math.max(0, Math.round((timerEnd() - Date.now()) / 1000));
      if (left <= 0) {
        timerText.textContent = config.timer.endText || '';
        timerEl.classList.add('is-over');
        stopTimer();
        return;
      }
      var mm = String(Math.floor(left / 60)).padStart(2, '0');
      var ss = String(left % 60).padStart(2, '0');
      var parts = String(config.timer.text || '{tiempo}').split('{tiempo}');
      timerText.innerHTML = esc(parts[0]) + '<b>' + mm + ':' + ss + '</b>' + esc(parts.slice(1).join(''));
    }
    function startTimer() {
      if (!timerEl || !config.timer || !config.timer.enabled) return;
      timerEl.hidden = false;
      tickTimer();
      if (!timerId) timerId = setInterval(tickTimer, 1000);
    }
    function stopTimer() {
      if (timerId) { clearInterval(timerId); timerId = null; }
    }
 
    function render(data) {
      cart = data;
      var entries = (data.items || []).map(function (item, index) { return { item: item, line: index + 1 }; });
      var protection = entries.filter(function (entry) { return isProtection(entry.item); })[0] || null;
      entries = entries.filter(function (entry) { return !isProtection(entry.item); });
      var items = entries.map(function (entry) { return entry.item; });
      var boxes = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      var mainBoxes = items.reduce(function (sum, item) { return sum + (Number(item.variant_id) === Number(config.variantId) ? item.quantity : 0); }, 0);
      setCount(boxes);
      ship.innerHTML = shipHTML(mainBoxes);
 
      if (!items.length && protection && !cleaning) {
        cleaning = true;
        change(protection.line, 0);
        return;
      }
      cleaning = false;
 
      if (protect) {
        protect.hidden = !items.length;
        protectInput.checked = !!protection;
        protect.dataset.line = protection ? protection.line : '';
      }
      if (timerEl) {
        if (items.length) { startTimer(); } else { timerEl.hidden = true; stopTimer(); }
      }
      if (!items.length) {
        body.innerHTML = '<div class="np-drawer__empty">' + ICONS.cart + '<h3>Tu carrito está vacío</h3><p>Elegí tu pack y empezá tu rutina con un parche por día.</p>' +
          '<button type="button" class="np-btn" data-np-drawer-shop>Elegir mi pack</button></div>';
        foot.hidden = true;
        return;
      }
      body.innerHTML = entries.map(itemHTML).join('') + upsellHTML(entries);
      var rowsHTML = '';
      if (data.total_discount > 0) {
        rowsHTML += '<p class="np-drawer__row"><span>Subtotal</span><span>' + money(data.original_total_price) + '</span></p>';
        rowsHTML += '<p class="np-drawer__row np-drawer__row--save"><span>Descuento del pack</span><span>−' + money(data.total_discount) + '</span></p>';
      }
      rowsHTML += '<p class="np-drawer__row np-drawer__row--total"><span>Total</span><strong>' + money(data.total_price) + '</strong></p>';
      rows.innerHTML = rowsHTML;
      foot.hidden = false;
    }
 
    function setBusy(on) {
      busy = on;
      panel.classList.toggle('is-busy', on);
    }
 
    function refresh() {
      setBusy(true);
      return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(render)
        .catch(function () {
          body.innerHTML = '<p class="np-drawer__error">No pudimos cargar el carrito. <a href="' + ROOT + 'cart">Ver carrito</a></p>';
        })
        .then(function () { setBusy(false); });
    }
 
    function toggleProtection(on) {
      if (busy || !config.protection) return;
      if (on) {
        setBusy(true);
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(config.protection.variantId), quantity: 1 }] })
        }).then(function () { setBusy(false); return refresh(); }).catch(function () { setBusy(false); refresh(); });
      } else {
        var line = Number(protect.dataset.line);
        if (line) change(line, 0);
      }
    }
 
    function change(line, quantity) {
      if ((busy && !cleaning) || !cart) return;
      var item = cart.items[line - 1];
      if (!item) return;
      var payload = { line: line, quantity: quantity };
      var hasKaching = item.properties && item.properties.__kaching_bundles;
      if (quantity > 0 && config.kaching && hasKaching && Number(item.variant_id) === Number(config.variantId)) {
        var pack = packFor(quantity);
        if (pack && pack.bar) payload.properties = { __kaching_bundles: kachingValue(pack) };
      }
      setBusy(true);
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito.');
          return data;
        });
      }).then(render).catch(function (err) {
        var note = document.createElement('p');
        note.className = 'np-drawer__error';
        note.textContent = err.message;
        body.insertBefore(note, body.firstChild);
      }).then(function () { setBusy(false); });
    }
 
    function open(trigger) {
      if (!drawer) return;
      lastFocus = trigger || document.activeElement;
      drawer.hidden = false;
      document.documentElement.classList.add('np-lock');
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        panel.focus({ preventScroll: true });
      });
      refresh();
    }
 
    function close() {
      if (!drawer || drawer.hidden) return;
      stopTimer();
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('np-lock');
      setTimeout(function () { drawer.hidden = true; }, 280);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
 
    function init() {
      var el = $('[data-np-drawer]');
      if (!el || el.dataset.npReady) return;
      el.dataset.npReady = '1';
      drawer = el;
      panel = $('.np-drawer__panel', drawer);
      body = $('[data-np-drawer-body]', drawer);
      foot = $('[data-np-drawer-foot]', drawer);
      rows = $('[data-np-drawer-rows]', drawer);
      ship = $('[data-np-ship]', drawer);
      protect = $('[data-np-protect]', drawer);
      protectInput = protect ? $('[data-np-protect-input]', protect) : null;
      timerEl = $('[data-np-timer]', drawer);
      timerText = timerEl ? $('[data-np-timer-text]', timerEl) : null;
      if (protectInput) protectInput.addEventListener('change', function () { toggleProtection(protectInput.checked); });
      var configEl = $('[data-np-cart-config]');
      try { config = JSON.parse(configEl ? configEl.textContent : '{}'); } catch (e) { config = {}; }
 
      $$('[data-np-cart-open]').forEach(function (link) {
        link.addEventListener('click', function (event) { event.preventDefault(); open(link); });
      });
      drawer.addEventListener('click', function (event) {
        var target = event.target;
        if (target.closest('[data-np-drawer-close]')) { close(); return; }
        if (target.closest('[data-np-drawer-shop]')) {
          close();
          var packs = $('.np-packs');
          if (packs) packs.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        var button = target.closest('[data-np-set]');
        if (button && !button.disabled) change(Number(button.dataset.npLine), Number(button.dataset.npSet));
      });
      document.addEventListener('keydown', function (event) {
        if (drawer.hidden) return;
        if (event.key === 'Escape') close();
        if (event.key === 'Tab') {
          var focusable = $$('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])', panel);
          if (!focusable.length) return;
          var first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    }
 
    return { init: init, open: open, close: close, available: available, refresh: refresh };
  })();
  window.NatyCart = NatyCart;
 
  /* ---------- Galería ---------- */
  function initGallery(root) {
    $$('[data-np-gallery]', root).forEach(function (gallery) {
      if (gallery.dataset.npReady) return;
      gallery.dataset.npReady = '1';
      var track = $('[data-np-gallery-track]', gallery);
      var slides = $$('.np-gallery__slide', track);
      var prev = $('[data-np-gallery-prev]', gallery);
      var next = $('[data-np-gallery-next]', gallery);
      var thumbs = gallery.parentElement.querySelector('[data-np-thumbs]');
      var active = 0;
      if (!track || !slides.length) return;
 
      if (thumbs && slides.length > 1) {
        slides.forEach(function (slide, index) {
          var img = slide.querySelector('img');
          var button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', 'Ver imagen ' + (index + 1));
          if (img) {
            var thumb = document.createElement('img');
            thumb.src = img.currentSrc || img.src;
            thumb.alt = '';
            thumb.loading = 'lazy';
            button.appendChild(thumb);
          }
          button.addEventListener('click', function () { go(index); });
          thumbs.appendChild(button);
        });
      }
      if (slides.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
      }
 
      function go(index) {
        index = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      }
      function update() {
        var width = track.clientWidth || 1;
        active = Math.round(track.scrollLeft / width);
        if (thumbs) {
          $$('button', thumbs).forEach(function (button, index) {
            button.setAttribute('aria-current', index === active ? 'true' : 'false');
          });
          var current = thumbs.children[active];
          if (current && current.scrollIntoView && thumbs.scrollWidth > thumbs.clientWidth) {
            thumbs.scrollTo({ left: current.offsetLeft - thumbs.clientWidth / 2 + current.clientWidth / 2, behavior: 'smooth' });
          }
        }
      }
      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });
      var timer;
      track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(update, 60); }, { passive: true });
      update();
    });
  }
 
  /* ---------- Packs y carrito ---------- */
  function initBuy(root) {
    $$('[data-np-buy]', root).forEach(function (form) {
      if (form.dataset.npReady) return;
      form.dataset.npReady = '1';
      var radios = $$('input[name="np_pack"]', form);
      var qtyInput = $('[data-np-qty]', form);
      var propInput = $('[data-np-prop]', form);
      var variantInput = $('[data-np-variant]', form);
      var totalLabel = $('[data-np-total]', form);
      var submit = $('[data-np-submit]', form);
      var error = $('[data-np-error]', form);
      var kaching = form.dataset.kaching === 'true';
      var busy = false;
 
      function selected() {
        return radios.filter(function (radio) { return radio.checked; })[0] || radios[0];
      }
      function kachingProperty(radio) {
        return JSON.stringify({
          deal: form.dataset.kachingDeal,
          pp: Number(form.dataset.productId),
          main: true,
          v: form.dataset.kachingVersion,
          bid: radio.dataset.bar
        });
      }
      function sync() {
        var radio = selected();
        if (!radio) return;
        radios.forEach(function (item) {
          var label = item.closest('.np-pack');
          if (label) label.classList.toggle('is-selected', item === radio);
        });
        if (qtyInput) qtyInput.value = radio.dataset.qty || '1';
        if (propInput) {
          propInput.disabled = !(kaching && radio.dataset.bar);
          propInput.value = kachingProperty(radio);
        }
        if (totalLabel && radio.dataset.total) totalLabel.textContent = radio.dataset.total;
      }
      radios.forEach(function (radio) { radio.addEventListener('change', sync); });
 
      function showError(message) {
        if (!error) return;
        error.textContent = message;
        error.hidden = false;
      }
 
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return; /* envío normal del formulario */
        event.preventDefault();
        if (busy) return;
        busy = true;
        if (error) error.hidden = true;
        if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); }
        var radio = selected();
        var item = { id: Number(variantInput.value), quantity: Number(radio ? radio.dataset.qty : 1) || 1 };
        if (kaching && radio && radio.dataset.bar) item.properties = { __kaching_bundles: kachingProperty(radio) };
 
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'No se pudo agregar el pack.');
            return data;
          });
        }).then(function () {
          busy = false;
          if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); }
          if (NatyCart.available()) {
            NatyCart.open(submit);
          } else {
            window.location.assign(ROOT + 'cart');
          }
        }).catch(function (err) {
          busy = false;
          if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); }
          showError(err.message || 'No se pudo agregar el pack. Probá de nuevo.');
        });
      });
 
      sync();
    });
  }
 
  /* ---------- Pestañas ---------- */
  function initTabs(root) {
    $$('[data-np-tabs]', root).forEach(function (tabs) {
      if (tabs.dataset.npReady) return;
      tabs.dataset.npReady = '1';
      var buttons = $$('[role="tab"]', tabs);
      function select(button) {
        buttons.forEach(function (item) {
          var on = item === button;
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () { select(button); });
        button.addEventListener('keydown', function (event) {
          var step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 0;
          if (!step) return;
          event.preventDefault();
          var target = buttons[(index + step + buttons.length) % buttons.length];
          select(target);
          target.focus();
        });
      });
    });
  }
 
  /* ---------- Carruseles ---------- */
  function initCarousels(root) {
    $$('[data-np-carousel]', root).forEach(function (carousel) {
      if (carousel.dataset.npReady) return;
      carousel.dataset.npReady = '1';
      var track = $('[data-np-track]', carousel);
      var prev = $('[data-np-prev]', carousel);
      var next = $('[data-np-next]', carousel);
      var dots = $('[data-np-dots]', carousel);
      if (!track) return;
      var items = Array.prototype.slice.call(track.children);
 
      function step() {
        var first = items[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function pages() {
        var perView = Math.max(1, Math.round(track.clientWidth / step()));
        return Math.max(1, items.length - perView + 1);
      }
      function index() { return Math.round(track.scrollLeft / step()); }
      function go(i) { track.scrollTo({ left: Math.max(0, i) * step(), behavior: 'smooth' }); }
 
      function buildDots() {
        if (!dots) return;
        dots.innerHTML = '';
        var total = pages();
        if (total < 2) return;
        for (var i = 0; i < total; i += 1) {
          (function (i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', 'Ir a ' + (i + 1));
            dot.addEventListener('click', function () { go(i); });
            dots.appendChild(dot);
          })(i);
        }
      }
      function update() {
        var current = index();
        var total = pages();
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (prev) { prev.disabled = track.scrollLeft <= 4; prev.hidden = total < 2; }
        if (next) { next.disabled = atEnd; next.hidden = total < 2; }
        if (dots) {
          $$('button', dots).forEach(function (dot, i) {
            dot.setAttribute('aria-current', (atEnd ? total - 1 : current) === i ? 'true' : 'false');
          });
        }
      }
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      var timer;
      track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(update, 60); }, { passive: true });
      window.addEventListener('resize', function () { buildDots(); update(); });
      buildDots();
      update();
    });
  }
 
  /* ---------- "Leer más" en reseñas ---------- */
  function initReviews(root) {
    $$('.np-review', root).forEach(function (review) {
      var text = $('[data-np-clamp]', review);
      var more = $('[data-np-more]', review);
      if (!text || !more || more.dataset.npReady) return;
      more.dataset.npReady = '1';
      if (text.scrollHeight > text.clientHeight + 6) more.hidden = false;
      more.addEventListener('click', function () {
        var open = review.classList.toggle('is-open');
        more.textContent = open ? 'Leer menos' : 'Leer más';
      });
    });
  }
 
  /* ---------- Videos: reproducción automática silenciosa ---------- */
  function initVideos(root) {
    $$('.np-ugc video', root).forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var attempt = video.play();
              if (attempt && attempt.catch) attempt.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: .25 }).observe(video);
      }
    });
  }
 
  /* ---------- Menú, botón flotante y anclas ---------- */
  function initChrome(root) {
    var menu = $('.np-menu', root);
    if (menu && !menu.dataset.npReady) {
      menu.dataset.npReady = '1';
      $$('[data-np-menu-close], nav a', menu).forEach(function (el) {
        el.addEventListener('click', function () { menu.open = false; });
      });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') menu.open = false; });
      menu.addEventListener('click', function (event) {
        if (event.target === menu) menu.open = false;
      });
    }
 
    var buy = document.getElementById('np-comprar');
    $$('[data-np-scroll-buy]', root).forEach(function (link) {
      if (link.dataset.npScrollReady) return;
      link.dataset.npScrollReady = '1';
      link.addEventListener('click', function (event) {
        if (!buy) return;
        event.preventDefault();
        var target = buy.querySelector('.np-packs') || buy;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
 
    var floating = $('[data-np-float]', root);
    var submit = buy ? buy.querySelector('[data-np-submit]') : null;
    if (floating && submit && !floating.dataset.npFloatReady) {
      floating.dataset.npFloatReady = '1';
      var footer = $('.np-footer');
      function refresh() {
        var rect = submit.getBoundingClientRect();
        var passed = rect.bottom < 0;
        var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
        var show = passed && !nearFooter;
        floating.classList.toggle('is-visible', show);
        floating.setAttribute('aria-hidden', show ? 'false' : 'true');
        floating.tabIndex = show ? 0 : -1;
      }
      window.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      refresh();
    }
  }
 
  /* ---------- Protección básica contra copia ---------- */
  function initProtection() {
    if (window.NatyDesignMode || document.body.dataset.npProtected) return;
    document.body.dataset.npProtected = '1';
    document.body.classList.add('np-copy-protected');
    document.addEventListener('contextmenu', function (event) { event.preventDefault(); }, true);
    document.addEventListener('dragstart', function (event) {
      if (event.target.closest && event.target.closest('img, video')) event.preventDefault();
    }, true);
    document.addEventListener('keydown', function (event) {
      var key = (event.key || '').toLowerCase();
      var mod = event.ctrlKey || event.metaKey;
      var inspect = event.key === 'F12' || (mod && (key === 'u' || key === 's')) ||
        (mod && event.shiftKey && (key === 'i' || key === 'j' || key === 'c')) ||
        (event.metaKey && event.altKey && (key === 'i' || key === 'j' || key === 'c'));
      if (inspect) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
  }
 
  /* ---------- Animaciones al hacer scroll ---------- */
  function initReveal(root) {
    var items = $$('[data-np-reveal]', root).filter(function (el) { return !el.dataset.npRevealReady; });
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    document.documentElement.classList.add('np-js');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); observer.unobserve(entry.target); }
      });
    }, { threshold: .15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { el.dataset.npRevealReady = '1'; observer.observe(el); });
  }
 
  function initTimeline(root) {
    $$('[data-np-timeline]', root).forEach(function (timeline) {
      if (timeline.dataset.npReady) return;
      timeline.dataset.npReady = '1';
      document.documentElement.classList.add('np-js');
      var steps = $$('[data-np-step]', timeline);
      var fill = $('[data-np-timeline-fill]', timeline);
      var ticking = false;
      function update() {
        ticking = false;
        var focus = window.innerHeight * 0.62;
        var rect = timeline.getBoundingClientRect();
        var progress = Math.min(1, Math.max(0, (focus - rect.top) / Math.max(1, rect.height)));
        if (fill) fill.style.height = (progress * 100) + '%';
        steps.forEach(function (step) {
          var top = step.getBoundingClientRect().top;
          step.classList.toggle('is-active', top < focus);
        });
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
 
  function init(root) {
    root = root || document;
    initGallery(root);
    initBuy(root);
    initTabs(root);
    initCarousels(root);
    initReviews(root);
    initVideos(root);
    initChrome(root);
    initReveal(root);
    initTimeline(root);
    NatyCart.init();
    initProtection();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();